/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Admin_Jobs_TitleInputs */

const vi_print_admin_jobs_title = /** @type {(inputs: Print_Admin_Jobs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hàng đợi in`)
};

/**

* @param {Print_Admin_Jobs_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_admin_jobs_title = /** @type {((inputs?: Print_Admin_Jobs_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Admin_Jobs_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_admin_jobs_title(inputs)
});